export const { REACT_APP_AWS_BUCKET_PATH, REACT_APP_API_URI } = process.env;
